export default function getEnv(name) {
  return window && window.configs && window.configs[name]
    ? window.configs[name]
    : process.env[name];
}
